import Vue from "vue";
import router from "./../../router/mobile";
import App from "./Index.vue";
import "normalize.css/normalize.css";
import "../../assets/reset.css";
import "../../assets/home/icon/remixicon.css";
import "fullpage.js/vendors/scrolloverflow";
import VueFullpage from "vue-fullpage.js";
import "../../assets/icon/iconfont.css";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import animated from "animate.css";
Vue.use(animated);
Vue.use(Antd);

import { Popup, Swipe, SwipeItem, Area, Button, Search,Empty } from "vant";
Vue.use(Popup);
Vue.use(Swipe);
Vue.use(Area);
Vue.use(Empty);
Vue.use(Search);
Vue.use(Button);
Vue.use(SwipeItem);
Vue.use(VueFullpage);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
